import { Button, Col, Row, Select, Tabs, } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ViewType } from '../../../../components/fileView/FileType';
import { useFetchFileViewer } from '../../../../components/fileView/FileViewer';
import { IModuleInfo } from '../../../../redux/progress/module/moduleInterface';
import { IState } from '../../../../redux/store';
import ModelParams from './modelParams';
import ModelTable from './modelTable';
import InputParams from './inputParams';
import SubmitGroup from '../../ResonanceModule/moduleParam/paramSubmit/SubmitGroup';
import { updateParam } from '../../../../redux/progress/param/paramAction'
import { IModuleParams } from '../../../../redux/progress/param/paramReducer';
import ModuleStatusViewer from '../../ResonanceModule/moduleStatusViewer/ModuleStatusViewer';
import QualityControl from './cualityControl';
import JobMonitoring from './jobMonitoring';
import type { TabsProps } from 'antd';
function EasyModel(props: {
    updateParam: (param: IModuleParams) => void,
}) {
    const { TabPane } = Tabs;
    const [line, setLine] = useState('')
    const [point, setPoint] = useState('')

    const [cancalData, setCancalData] = useState<any>()

    const [btnStatus, setBtnStatus] = useState(false)

    const [tableBtn, setTableBtn] = useState<boolean>(false)
    const [tableempty, setTableempty] = useState<boolean>(false)
    const [tabKey, setTabKey] = useState<string>('1')
    const  callback =(key: any) => {
        setTabKey(key)
      }
    return <>
        <Row gutter={25}>
            <Col span={8}>
                <ModelParams cancalData={cancalData} btnStatus={setBtnStatus} tablebtn={tableBtn} empty={setTableempty} />
            </Col>
            <Col span={16}>
                <Tabs type="card" size='large'onChange={callback} >
                    <TabPane tab="表格" key="1">
                        <div>
                            <ModelTable line={line} point={point} cancalData={setCancalData} status={btnStatus} tableBtn={setTableBtn} empty={tableempty} />
                            <InputParams line={setLine} point={setPoint} status={btnStatus} tableBtn={tableBtn} />
                        </div>
                    </TabPane>
                    <TabPane tab="质控显示" key="2" >
                        <QualityControl  tabKey = {tabKey}/>
                    </TabPane>
                    <TabPane tab="作业监控" key="3">
                        <JobMonitoring tabKey = {tabKey}/>
                    </TabPane>
                </Tabs>
            </Col>


        </Row>


    </>
}

const mapStateToProps = (state: IState) => {
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
    };
};

export default connect(
    mapStateToProps,
    { updateParam }
)(EasyModel);